/* import { useFormik } from "formik";
import React, { useMemo } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { Col, Container, Form, Input, Row } from "reactstrap";
import * as Yup from "yup";

import { TicketFieldSetting } from "src/sdk/models/Organisation";
import { TicketService } from "src/services/TicketService";

export const CreateTicket: React.FC = () => {
  const history = useHistory();
  const location = useLocation();
  const service = new TicketService();

  const fields: TicketFieldSetting[] = (location.state.fields || []).filter(
    (f: any) => {
      return (
        f.name.toLowerCase() !== "id" &&
        f.name !== "ticketId" &&
        f.name !== "filemakerUUID" &&
        f.name !== "createdAt" 
      );
    }
  );

  const initialValues = useMemo(() => {
    const obj: any = {};
    fields.forEach(f => {
      obj[f.name] = "";
    });
    return obj;
  }, [fields]);

  const validationSchema = useMemo(() => {
    const shape: any = {};
    fields.forEach(f => {
      shape[f.name] = Yup.string().nullable();
    });
    return Yup.object(shape);
  }, [fields]);
          console.log(location.state.organisation)
  const form = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema,
    onSubmit: (values) => {
      console.log(values)
      service.createTicket(values)
        .then(() => {
                  console.log(location.state.organisation)

          toast.success("Ticket created successfully");
          history.push({
            pathname:"/ticketing",
          state: location.state.organisation});
        })
        .catch(() => toast.error("Creation failed"));
    }
  });

  const renderField = (f: TicketFieldSetting) => {
    const error = form.touched[f.name] && form.errors[f.name];

    if (f.type === "textarea") {
      return (
        <Input
          type="textarea"
          name={f.name}
          rows={5}
          value={form.values[f.name]}
          onChange={form.handleChange}
          onBlur={form.handleBlur}
          invalid={!!error}
        />
      );
    }

    return (
      <Input
        type="text"
        name={f.name}
        value={form.values[f.name]}
        onChange={form.handleChange}
        onBlur={form.handleBlur}
        invalid={!!error}
      />
    );
  };

  return (
    <Form onSubmit={form.handleSubmit}>
      <Container fluid>

        <div className="d-flex align-items-center mb-4">
          <Link to={{
            pathname:"/ticketing",
          state: location.state.organisation}} style={{ color: "black" }}>
            <h5>Ticketing</h5>
          </Link>
          <i className="bi bi-chevron-right mx-2" />
          <h5 style={{ opacity: 0.6 }}>Create Ticket</h5>
        </div>

        {fields.map(f => (
          <Row key={f.name} className="mb-3">
            <Col lg={3}>
              <label className="fw-bold">{f.label}:</label>
            </Col>

            <Col lg={9}>
              {renderField(f)}
            </Col>
          </Row>
        ))}

      </Container>

      <Container fluid>
        <div className="d-flex flex-row-reverse mt-4">
          <button
            type="submit"
            className="btn btn-primary"
            style={{ backgroundColor: "#95CBB2", border: 0 }}
          >
            Save
          </button>

          <Link to={{
            pathname:"/ticketing",
          state: location.state.organisation}} className="btn btn-secondary me-2">
            Cancel
          </Link>
        </div>
      </Container>

    </Form>
  );
};
 */

import { useFormik } from "formik";
import React, { useMemo } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { Col, Container, Form, Input, Row } from "reactstrap";
import * as Yup from "yup";

import { useUserContext } from "src/globals/providers";
import { OrganisationType, TicketFieldSetting } from "src/sdk/models/Organisation";
import { TicketService } from "src/services/TicketService";

export const CreateTicket: React.FC = () => {
  const history = useHistory();
  const location: any = useLocation();
  const service = new TicketService();
  const { user } = useUserContext();

  const organisation = location.state.organisation;

  // Polja koja korisnik može editovati
  const visibleEditableFields = ["subject", "description"];

  // Polja koja su disabled, ali se prikazuju sa labelama
  let visibleDisabledFields = [
    "facilityName",
  ];
  if (organisation.type === OrganisationType.Facility) {
    console.log(organisation);
    visibleDisabledFields = [
      "facilityName",
      "status",
      "contact",
      "createdBy"
    ];
  } else if (organisation.type === OrganisationType.FacilityGroup) {
    visibleDisabledFields = [
      "facilityGroupName",
      "status",
      "contact",
      "createdBy"
    ];
  }
  console.log(user)
  // Uzimamo samo editable polja iz FieldSettings
  const editableFieldSettings: TicketFieldSetting[] = (location.state.fields || [])
    .filter((f: TicketFieldSetting) => visibleEditableFields.includes(f.name));

  // --- Mapiranje labela za sva polja (editable + disabled)
  const fieldLabelMap: Record<string, string> = {};
  location.state.fields.forEach((f: TicketFieldSetting) => {
    fieldLabelMap[f.name] = f.label;
  });

  // --- Initial values ---
  const initialValues = useMemo(() => {
    const obj: any = {};

    // Editable fields
    editableFieldSettings.forEach(f => {
      obj[f.name] = "";
    });

    // Disabled fields (default values from organisation)
    organisation.type === OrganisationType.Facility ? obj.facilityName = organisation.name : obj.facilityGroupName = organisation.name;
    obj.status = "New";
    obj.contact = user?.username;
    obj.createdBy = user?.username;
    obj.organisationUniqueKey = organisation.organisationUniqueKey;

    return obj;
  }, [editableFieldSettings, organisation]);

  // Validation
  const validationSchema = Yup.object({
    subject: Yup.string().required("Required"),
    description: Yup.string().required("Required")
  });

  // Formik
  const form = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema,
    onSubmit: (values) => {
      service.createTicket(values)
        .then(() => {
          toast.success("Ticket created successfully");
          history.push({
            pathname: "/ticketing",
            state: organisation
          });
        })
        .catch(() => toast.error("Creation failed"));
    }
  });

  // Render editable field
  const renderEditableField = (f: TicketFieldSetting) => (
    <Row key={f.name} className="mb-3">
      <Col lg={3}>
        <label className="fw-bold">{f.label}:</label>
      </Col>

      <Col lg={9}>
        {f.type === "textarea" ? (
          <Input
            type="textarea"
            rows={5}
            name={f.name}
            value={form.values[f.name]}
            onChange={form.handleChange}
            onBlur={form.handleBlur}
          />
        ) : (
          <Input
            type="text"
            name={f.name}
            value={form.values[f.name]}
            onChange={form.handleChange}
            onBlur={form.handleBlur}
          />
        )}
      </Col>
    </Row>
  );

  return (
    <Form onSubmit={form.handleSubmit}>
      <Container fluid>

        {/* Header */}
        <div className="d-flex align-items-center mb-4">
          <Link
            to={{ pathname: "/ticketing", state: organisation }}
            style={{ color: "black" }}
          >
            <h5>Ticketing</h5>
          </Link>
          <i className="bi bi-chevron-right mx-2" />
          <h5 style={{ opacity: 0.6 }}>Create Ticket</h5>
        </div>

        {/* Disabled Fields */}
        {visibleDisabledFields.map((fieldName) => (
          <Row key={fieldName} className="mb-3">
            <Col lg={3}>
              <label className="fw-bold">
                {fieldLabelMap[fieldName] ?? fieldName}:
              </label>
            </Col>

            <Col lg={9}>
              <Input
                name={fieldName}
                className="form-control"
                value={form.values[fieldName]}
                disabled
              />
            </Col>
          </Row>
        ))}

        {/* Editable Fields */}
        {editableFieldSettings.map(f => renderEditableField(f))}

      </Container>

      {/* Buttons */}
      <Container fluid>
        <div className="d-flex flex-row-reverse mt-4">
          <button
            type="submit"
            className="btn btn-primary"
            style={{ backgroundColor: "#95CBB2", border: 0 }}
          >
            Save
          </button>

          <Link
            to={{ pathname: "/ticketing", state: organisation }}
            className="btn btn-secondary me-2"
          >
            Cancel
          </Link>
        </div>
      </Container>
    </Form>
  );
};
